import View from './View';

export { default as View, getContentModalStyles } from './View';
export const useViewModel = (props) => props;

export default View;
